import { CUSTOMIZATION_TYPE } from './CustomizeUIConstants';
import getCustomPagesApis from './getCustomPagesApis';
import CustomizeBlockPageBaseStore from './CustomizeBlockPageBaseStore';

export default class CustomizeRegistrationNoticeStore extends CustomizeBlockPageBaseStore {
    constructor(data = { }) {
        super({}, /** @class CustomizeRegistrationNoticeStore */{
            ...getCustomPagesApis('REGISTRATION_NOTICE'),
            metadata: {
                customizationType: CUSTOMIZATION_TYPE.REGISTRATION_NOTICE,
                type: 'Notification',
                name: 'Registration Notice',
                description: 'Create terms users must accept before browsing.',
            },
        }, data);
    }
}
